// extracted by mini-css-extract-plugin
export default {"footer":"add-bank-account_footer__c69GZ","row":"add-bank-account_row__7I371","control":"add-bank-account_control__L84Rt"};